import axios from 'axios';

export default {
  namespaced: true,
  state() {
    return {
      routeHistory: [],
      categories: JSON.parse(localStorage.getItem('categories')) || [],
      startData: null,
      isFetchingStartData: false,
      isLoading: false
    };
  },
  mutations: {
    ADD_ROUTE(state, route) {
      state.routeHistory.push(route);
    },
    CLEAR_HISTORY(state) {
      state.routeHistory = [];
    },
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
      localStorage.setItem('categories', JSON.stringify(categories)); 
    },
    SET_START_DATA(state, data) {
      state.startData = data;  
    },
    SET_FETCHING_START_DATA(state, status) {
      state.isFetchingStartData = status;
    },
    MUTATE_LOADING(state, loading){
      state.isLoadin - loading
    }
  },
  actions: {
    addRoute({ commit }, route) {
      commit('ADD_ROUTE', route);
    },
    setLoading({ commit }, loading) {
      commit('MUTATE_LOADING', loading);
    },
    clearHistory({ commit }) {
      commit('CLEAR_HISTORY');
    },
    async fetchCategories({ commit }) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_API_URI}/api/public/categories`);
        commit('SET_CATEGORIES', response.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    },
    async fetchStartData({ commit, state, rootState }) {
      if (state.isFetchingStartData) {
        return;
      }
      commit('SET_FETCHING_START_DATA', true);
      try {
        const language = rootState.language.currentLanguage; 
        let langParam = 'pt'; 
        if (language === 'es-PY') {
          langParam = 'es';
        }
        const response = await axios.get(`${process.env.VUE_APP_API_URI}/api/public/start?lang=${langParam}`);
        commit('SET_START_DATA', response.data);
      } catch (error) {
        console.error('Error fetching start data:', error);
      } finally {
        commit('SET_FETCHING_START_DATA', false);
      }
    },
  },
  getters: {
    getCategories(state) {
      return state.categories;
    },
    getStartData(state) {
      return state.startData; 
    },
    getIsLoading(state){
      return state.isLoading
    }
  },
};
